module.exports = __webpack_public_path__ + "static/media/daisyChainFirstScreen.233d6548.png";